export default __webpack_public_path__ + "static/media/mask4.b935ee0f.jpg";